export default __webpack_public_path__ + "media/gs_upgrade_email/insta-03f0fa5a.png";